import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { FileText, Check, BellRing } from "lucide-react";
import { tr } from "../../lib/i18n";

// Looping "drop → filed → reminder" demo inside the hero mock card. Pure CSS/Framer, no video.
const STEPS = [
  { key: "drop", ms: 2200 },
  { key: "filed", ms: 3000 },
  { key: "reminder", ms: 2600 },
];

export const HeroDemo = () => {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setTimeout(() => setI((n) => (n + 1) % STEPS.length), STEPS[i].ms);
    return () => clearTimeout(t);
  }, [i]);
  const step = STEPS[i].key;
  return (
    <div className="mt-4 rounded-2xl border border-primary/30 bg-primary/5 px-4 py-3 text-xs min-h-[64px] relative overflow-hidden" data-testid="hero-demo" data-step={step} aria-live="polite">
      <AnimatePresence mode="wait">
        {step === "drop" && (
          <motion.div key="drop" initial={{ opacity: 0, y: -18 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, scale: 0.96 }} transition={{ duration: 0.45 }} className="flex items-center gap-3">
            <span className="h-9 w-9 rounded-xl bg-background border border-border grid place-items-center shrink-0"><FileText className="h-4 w-4 text-muted-foreground" /></span>
            <div className="min-w-0"><div className="font-medium truncate">{tr("IMG_4821.pdf")}</div><div className="text-muted-foreground">{tr("Dropped in from email · reading…")}</div></div>
            <span className="ml-auto h-2 w-2 rounded-full bg-primary animate-pulse" />
          </motion.div>
        )}
        {step === "filed" && (
          <motion.div key="filed" initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }} transition={{ duration: 0.45 }} className="flex items-center gap-3">
            <span className="h-9 w-9 rounded-xl bg-emerald-100 text-emerald-700 grid place-items-center shrink-0"><Check className="h-4 w-4" /></span>
            <div className="min-w-0"><div className="font-medium truncate">{tr("Auto insurance — declarations page")}</div><div className="text-muted-foreground flex flex-wrap gap-x-2">{tr("Insurance · Auto")} <span>·</span> {tr("Renews Nov 3")} <span>·</span> <span className="text-emerald-700 font-medium">{tr("96% sure")}</span></div></div>
            <span className="ml-auto text-[10px] uppercase tracking-wider font-mono text-primary">{tr("You approve")}</span>
          </motion.div>
        )}
        {step === "reminder" && (
          <motion.div key="reminder" initial={{ opacity: 0, x: 16 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0 }} transition={{ duration: 0.45 }} className="flex items-center gap-3">
            <span className="h-9 w-9 rounded-xl bg-amber-100 text-amber-700 grid place-items-center shrink-0"><BellRing className="h-4 w-4" /></span>
            <div className="min-w-0"><div className="font-medium">{tr("Concierge")}</div><div className="text-muted-foreground">{tr("Auto policy renews in 19 days — the new page is already filed.")}</div></div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
